interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "Article" | "FAQPage" | "CollectionPage";
  data?: Record<string, unknown>;
}

const baseData = {
  Organization: {
    "@type": "Organization",
    name: "樱花动漫网",
    url: "http://yuanyunge.cn/",
    description: "樱花动漫网提供免费高清动漫、电视剧、电影在线观看，一站式动漫大全平台。",
    sameAs: ["#", "#", "#"],
  },
  WebSite: {
    "@type": "WebSite",
    name: "樱花动漫网",
    url: "http://yuanyunge.cn/",
    description: "免费高清动漫在线观看平台，海量动漫、电视剧、电影资源尽在樱花动漫网。",
    inLanguage: "zh-CN",
  },
  WebPage: {
    "@type": "WebPage",
    name: "樱花动漫网 - 首页",
    url: "http://yuanyunge.cn/",
    description: "樱花动漫网首页，推荐最新热门动漫、电视剧、电影在线观看，免费高清动漫大全。",
    inLanguage: "zh-CN",
    isPartOf: {
      "@type": "WebSite",
      name: "樱花动漫网",
      url: "http://yuanyunge.cn/",
    },
  },
};

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  if (type === "Organization" || type === "WebSite" || type === "WebPage") {
    schema = { "@context": "https://schema.org", ...baseData[type], ...data };
  } else {
    schema = { "@context": "https://schema.org", "@type": type, ...data };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}